import { getRuntimeUrl } from '@common/services/storage';

/**
 * WhatsApp's doodle wallpaper, themed by the STYLESHEET, not by JS.
 *
 * Four surfaces used to pick the light or dark tile in JS —
 * `backgroundImage: isDark ? url(dark) : url(bright)` — and each asked a
 * different question to decide `isDark`:
 *
 *   compose-dialog preview, chat sidebar list  -> `whatsappDarkMode`
 *   AI assistant, team-inbox chat              -> `user.isDarkMode`
 *
 * Neither flag is the theme. `whatsappDarkMode` is written ONLY by the
 * extension's observer on WhatsApp's `<body class="dark">`, so in the web app it
 * is false forever and the compose preview kept its cream wallpaper beside a dark
 * dialog in every order of actions (measured: open-then-flip, flip-then-open,
 * flip twice — all `wa_bg_bright`). `user.isDarkMode` is the WEB APP's
 * preference, so inside WhatsApp it follows the wrong app's setting.
 *
 * The one signal that is right in every host is the one the stylesheet already
 * keys on: a `.dark` or `[data-theme="dark"]` ancestor (`body` in the web app,
 * the shadow root's `.btcss` wrapper and portal container in the extension, the
 * campaigns shell's own `data-theme`). So JS now supplies only what CSS cannot
 * know — the two tile URLs, which in the extension are `chrome-extension://`
 * URLs only JS can build — and CSS chooses between them. Nothing about the theme
 * is read or cached in JS, so there is nothing left to go stale.
 *
 * Spread into an MUI `sx`. The selector list must match the token file's dark
 * switch (`color-scheme-tokens.css`, "THE DARK SWITCH").
 */
export const WA_WALLPAPER_DARK_SELECTOR = '.dark &, [data-theme="dark"] &';

export function waWallpaperSx() {
    return {
        '--wa-wallpaper-light': `url(${getRuntimeUrl('/img/wa_bg_bright.jpg')})`,
        '--wa-wallpaper-dark': `url(${getRuntimeUrl('/img/wa_bg_dark.jpg')})`,
        backgroundImage: 'var(--wa-wallpaper-light)',
        backgroundRepeat: 'repeat',
        [WA_WALLPAPER_DARK_SELECTOR]: {
            backgroundImage: 'var(--wa-wallpaper-dark)',
        },
    } as const;
}
